import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { installAppGlobals } from "./plugins/appGlobals";
import { installHead } from "./plugins/head";
import { createPinia, setActivePinia } from "pinia";

import axios from "axios";
import firebase from "firebase/compat/app";
import { ensureApiSession, clearApiSession } from "./components/toLoad/api";

import "./registerServiceWorker";

import "./sass/style.css";
import "./sass/animations.css";
import "./sass/tokens.scss";
import "./sass/quality.css";
import "./sass/vuetify-density.css";
import "./sass/vuetify-legacy.css";

import { captureException, identify, initPostHog } from "./posthog";
import reveal from "./directives/reveal";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

initPostHog();

axios.interceptors.response.use(
  response => response,
  (error) => {
    const status = error.response?.status;
    const isNetworkError = !error.response;

    if (isNetworkError || (status && status >= 500))
      captureException(error, {
        flow: "axios",
        status: status || null,
        url: error.config?.url,
        method: error.config?.method,
      });

    return Promise.reject(error);
  },
);

const pinia = createPinia();
setActivePinia(pinia);

let appMounted = false;

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    identify(user.uid, {
      email: user.email,
      name: user.displayName,
    });
    ensureApiSession().catch(() => {});
  } else
    clearApiSession();

  if (appMounted) return;
  appMounted = true;

  const app = createApp(App);

  app.config.errorHandler = (err, instance, info) => {
    captureException(err, {
      flow: "vue",
      component: instance?.type?.name || instance?.$.type?.name || null,
      info,
    });
    if (process.env.NODE_ENV === "development") console.error(err);
  };

  installAppGlobals(app);
  installHead(app);

  app.component("VueEditor", QuillEditor);
  app.component("vue-editor", QuillEditor);

  app.directive("reveal", reveal);
  app.use(pinia);
  app.use(router);
  app.use(vuetify);
  app.mount("#app");
});
